module.exports = "images/bulging-production-pipe-1dd4bec036a06a91ef363939c4f3f948.png";